module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-toggle inner-x"
  }, [_c('svg-icon', {
    staticClass: "toggle-trigger",
    attrs: {
      "name": "menu"
    },
    on: {
      "click": function($event) {
        _vm.toggleSidebar()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-006d85a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarToggle.vue
// module id = 98
// module chunks = 0